import hexRgb from 'hex-rgb';

const hexToRGB = ({ color, alpha = 1 }) => hexRgb(color, { format: 'css', alpha });

export default hexToRGB;
